import { render, staticRenderFns } from "./SocialLocationModal.vue?vue&type=template&id=398fce12&scoped=true"
import script from "./SocialLocationModal.vue?vue&type=script&lang=ts"
export * from "./SocialLocationModal.vue?vue&type=script&lang=ts"
import style0 from "./SocialLocationModal.vue?vue&type=style&index=0&id=398fce12&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "398fce12",
  null
  
)

export default component.exports